import React, { ReactElement } from 'react';
import ActivityItem from './activity-item';
import { RemoteActivity, RemoteOrganizer } from '../types';

interface ActivitiesFilterResultPageProps {
  activities: RemoteActivity[];
  organizers: RemoteOrganizer[];
}

export default function ActivitiesFilterResultPage(props: ActivitiesFilterResultPageProps): ReactElement {
  return (
    <div id="activities-ts-activity-item" className="ts-activity-item">
      <div className="ts-activity-item-title page-title-box">
        <div className="ts-activity-item-title-wrap page-title-box-inner content-bg">
          <h1>Aktiviteter</h1>
        </div>
      </div>
      <div className="ts-activity-item-scroll-outer">
        <div className="scroll-wrapper ts-activity-item-scroll scrollbar-inner">
          <div>
            {props.activities.map((a) => (
              <ActivityItem
                key={a.id}
                id={a.id}
                title={a.title}
                description={a.description}
                organizer={a.organizer}
                type={a.type}
                date={a.date}
                time={a.time}
                day={a.day}
                requiresMembership={a.requiresMembership}
                isBookedUp={a.isBookedUp}
                allowsReserves={a.allowsReserves}
                imageUri={a.imageUri}
                link={a.link}
                organizers={props.organizers}
                isRegistrationOpen={a.isRegistrationOpen}
                bookable={a.bookable}
                numberOfOccurrences={a.numberOfOccurrences}
                url={a.url}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
